import { render, staticRenderFns } from "./integralMall.vue?vue&type=template&id=29c5d2a2&scoped=true"
import script from "./integralMall.vue?vue&type=script&lang=js"
export * from "./integralMall.vue?vue&type=script&lang=js"
import style0 from "./integralMall.vue?vue&type=style&index=0&id=29c5d2a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c5d2a2",
  null
  
)

export default component.exports